<template>
    <div class="column">
        <div style=" height: 100%;display: flex;  flex-direction: column;">
            <div class="text-center">Select Excellent Signature Cases Template</div>
            <el-divider />
            <div style="flex: 1; padding: 10px;">
                <div v-if="store.resultUrl"
                    style="height: 100%;display: flex; align-items: center; padding: 0 20px; flex-direction: column; justify-content: space-around;">
                    <img :src="store.resultUrl">
                    <el-button type="primary" @click="handleDownload">Download</el-button>
                </div>
                <div v-else-if="store.loading"
                    style="height: 100%;display: flex; align-items: center; padding: 0 20px;">
                    <img
                        src="https://ap-data-us-oss.oss-us-west-1.aliyuncs.com/myaha/web/StyleTransform/static/img/loding.4f278a67.gif">
                </div>
                <div v-else class="grid-3">
                    <div :class="{ item: true, active: store.example === 'music' }" @click="handleEaxmple('music')">
                        <div class="img square"
                            style="background-image: url(https://cdn.signmaker.io/signmaker/web/3n1/logoSign/images/sign-music.png);">
                        </div>
                        <div class="text-center" style="text-align: center;"> Music Signature </div>
                    </div>
                    <div :class="{ item: true, active: store.example === 'bird' }" @click="handleEaxmple('bird')">
                        <div class="img square"
                            style="background-image: url(https://cdn.signmaker.io/signmaker/web/3n1/logoSign/images/sign-bird.png);">
                        </div>
                        <div class="text-center" style=" text-align: center;"> Bird Signature </div>
                    </div>
                    <div :class="{ item: true, active: store.example === 'butterfly' }"
                        @click="handleEaxmple('butterfly')">
                        <div class="img square"
                            style="background-image: url(https://cdn.signmaker.io/signmaker/web/3n1/logoSign/images/sign-butterfly.png);">
                        </div>
                        <div class="text-center" style="text-align: center;"> ButterFly signature </div>
                    </div>
                    <div :class="{ item: true, active: store.example === 'cat' }" @click="handleEaxmple('cat')">
                        <div class="img square"
                            style="background-image: url(https://cdn.signmaker.io/signmaker/web/3n1/logoSign/images/sign-cat.png);">
                        </div>
                        <div class="text-center" style=" text-align: center;"> Cat Signature </div>
                    </div>
                    <div :class="{ item: true, active: store.example === 'flower' }" @click="handleEaxmple('flower')">
                        <div class="img square"
                            style="background-image: url(https://cdn.signmaker.io/signmaker/web/3n1/logoSign/images/sign-flower.webp);">
                        </div>
                        <div class="text-center" style="text-align: center;"> Flower Signature </div>
                    </div>
                    <div :class="{ item: true, active: store.example === 'star' }" @click="handleEaxmple('star')">
                        <div class="img square" style="background-image: url(https://cdn.signmaker.io/signmaker/web/3n1/logoSign/images/sign-star.png);">
                        </div>
                        <div class="text-center" style=" text-align: center;"> Star Signature </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
<script name="Home" setup>
import { UploadFilled, } from '@element-plus/icons-vue'
import { reactive, onMounted, ref, computed, inject } from 'vue';
import { getFingerprint } from '@/utils/finger'
import { useStore } from "@/stores"

const store = useStore()

const handleEaxmple = (value) => {
    store.setEaxmple(value)
}
function getFileExtension(url) {
    return url.split('.').pop().split(/\#|\?/)[0];
}
const handleDownload = () => {
    let url = store.resultUrl;
    const extension = getFileExtension(url);
    const fileName = `signmaker.${extension}`;

    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const urlObject = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = urlObject;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(urlObject); // 释放URL对象
        })
        .catch(error => console.error('Download error:', error));
};

onMounted(async () => {
    const fingerprint = await getFingerprint()
    store.setFingerprint(fingerprint)
});



</script>
<style scoped>
.grid-3 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 0 17px;
}

.square {
    border: 3px dashed #d9d9d9;
    border-radius: 8px;
    height: 160px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #fff;
}

.item.active .square {
    border: 3px solid #409eff;
}

.text-center {
    text-align: center;
}
</style>